<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->
<div
	class="splash-loader-layer"
	[ngClass]="{ 'splash-loader-dark': transparent, 'splash-loader-solid': !transparent }"
	[ngStyle]="{ position: displayGlobally ? 'fixed' : 'absolute' }"
>
	<div class="centering-wrapper sl-spinner">
		<div class="splash-spinner"></div>
	</div>
	<ng-container *ngIf="customContent" [ngTemplateOutlet]="customContent"></ng-container>
</div>
